import { rangeBetween, shuffle } from '~/utils'

/** bootcamp/pizza/9-9.png was never authored — the only gap in the art, so part 9 of a 9-part pizza
 *  draws nothing and the student counts a slice short. Every other part of every other pizza exists. */
const ARTLESS_DENOMINATOR = 9

export interface PizzaParts {
  /** Parts that get a pizza slice drawn on top of the empty plate. */
  shownParts: number[]
  /** Parts left empty — what the student counts in FractionPizza1. */
  missingParts: number[]
}

/**
 * Splits the pizza's parts into the ones showing a slice and the ones left empty.
 * `type` 1 draws the complement of the numerator (so the numerator is the missing slices),
 * `type` 2 draws the numerator itself (so the numerator is the remaining slices).
 */
export function generatePizzaParts(
  denominator: number,
  numerator: number,
  isPiecesTogether: boolean,
  type: number,
): PizzaParts {
  const isArtless = denominator === ARTLESS_DENOMINATOR
  // rangeBetween is end-exclusive, so the last drawable part needs the +1 to be drawable at all.
  let parts: number[] = rangeBetween(1, isArtless ? denominator : denominator + 1)
  if (!isPiecesTogether) parts = shuffle(parts)
  const shownCount = type === 1 ? denominator - numerator : numerator
  const missingParts = parts.slice(shownCount)
  return {
    shownParts: parts.slice(0, shownCount),
    // A fraction always leaves a part empty, so the artless one can always be that part.
    missingParts: isArtless ? [...missingParts, denominator] : missingParts,
  }
}

/** Maps pizza parts to their CDN image keys. */
export function toImageSrcKeys(denominator: number, parts: number[]): string[] {
  return parts.map((part) => `bootcamp/pizza/${denominator}-${part}.png`)
}
